export default "__VITE_ASSET__WI3xkq2w__"